import React from 'react';
import './AboutView.less';
import {Row, Item, Column} from 'react-plan';

type Props = {

}

class AboutView extends React.Component {

  description: 'The about view.'

  props: Props

  constructor(props: Props) {
    super(props);
  }

  /* Component Custom Methods */
  /* End Component Custom Methods */

  /* React Component LifeCycle Methods */
  //componentWillMount() {}
  //componentDidMount() {}
  //componentWillReceiveProps(nextProps) {}
  //shouldComponentUpdate(nextProps, nextState) {}
  //componentWillUpdate(nextProps, nextState) {}
  //componentDidUpdate(prevProps, prevState) {}
  //componentWillUnmount() {}
  render() {
    return (
      <div className="about-view">
        <div className="bg-white-shadow2 bg-img4">
          <div className="bloc-medium m-t-xl m-b-xxl">
            <Item>
              <h1 className="m-t-xxl m-b txt-center v-center mobile-bold" >
                WORLD TOP QUALITY<br/>
                SPACE EDUCATION TO ALL PEOPLE<br/>
                IN THE WORLD
              </h1>
            </Item>
            <p className="txt-center mobile-bold">Space is frontier for human being as well as dream or hope for all the people. Space technology makes improve human life all over the world by efficiently using it. In particular, it is able to realize safe and peaceful livelihood, high-quality life, and economy development. It is necessary for all the people of the earth to have education and/or capacity building of developing and utilizing space technology to enjoy its significant benefit. We provide world top quality space education for next generation and future. Let’s join the World Space School so that you can acquire the enough capacity of space development and utilization.</p>
          </div>
        </div>

        <div>
          <div className="bloc-small  m-t-xl m-b-xxl">
            <p className="m-b txt-center">‘World Space School' is the only comprehensive system enable students, engineers, managers, administrative official, professionals, etc. who want to learn space technology to access to world top quality space education. In the best combinations of wide varieties of educational tools, e.g. e-learning, face-to-face lecture, workshop, hands-on, and so on, you can acquire the necessary capacity for space development and utilization. We prepare Prof. Shinichi Nakasuka, Prof. Ryosuke Shibasaki and other names of great note who active in the front lines in the world for top quality of capacity building. Another unique specialty of World Space School is to have interactive sessions(live or online Q&A etc.) to solve each trainee’s different level of questions immediately without being left unsolved.</p>
          </div>
          <hr/>
        </div>

        <div>
          <div className="bloc-large m-t-xl m-b-xl">
            <h2 className="m-t-xl m-b-xxl txt-center">Our parteners</h2>
            <Row justify="space-between" align="center">
              <Item className="p txt-center" align="center" medium="50%" small="100%">
                <img src={require('../../../img-layout/logo1.png') } alt="logo" />
              </Item>
              <Item className="p txt-center" align="center" medium="50%" small="100%" >
                <img src={require('../../../img-layout/logo2.png') } alt="logo" />
              </Item>
              <Item className="p txt-center" align="center" medium="50%" small="100%">
                <img src={require('../../../img-layout/logo3.png') } alt="logo" />
              </Item>
              <Item className="p txt-center" medium="50%" align="center" small="100%">
                <img src={require('../../../img-layout/logo4.png') } alt="logo" />
              </Item>
              {/* <Item className="p txt-center" medium="50%" align="center" small="100%">
                <img src={require('../../../img-layout/logo5.png') } alt="logo" />
              </Item> */}
            </Row>
          </div>
          {/* <hr/> */}
        </div>

        {/*<div className="bloc-medium m-t-xl m-b-xxl">

          <h2 className="m-t-xxl m-b-xxl txt-center">Key Stakeholders</h2>

          <Row className="m-t-xl">
            <Column className="m-r m-b" size="33%" small="100%">
              <img className="img-prof" src={require('../../../img-layout/img16-9.jpg') } alt="prof-img" />
            </Column>
            <Column className="" small="100%">
              <h3>Professor Nakasuka</h3>
              <p className="m-t">Minim mollit eiusmod culpa laborum ad laboris cupidatat.Ipsum sunt consequat non in nostrud cillum reprehenderit voluptate dolore.Nulla veniam fugiat laborum consequat eu dolor ex sit sint magna.
                Nisi proident quis commodo incididunt.Labore sint proident officia id.Ea sit amet dolore est nulla dolor labore non dolore eu aliquip nisi.Quis do cupidatat in culpa et laboris consectetur excepteur nisi.Laboris Lorem cupidatat veniam incididunt amet sit.Veniam in adipisicing exercitation pariatur.Minim deserunt amet enim consectetur duis nostrud est pariatur ea.
                In nulla laboris ut quis consequat id dolor deserunt.Aliquip Lorem proident laboris in dolor Lorem eu adipisicing est consectetur et sit.Irure labore deserunt voluptate excepteur.
                Velit elit eiusmod est nostrud consectetur ad.Non adipisicing mollit cillum qui id qui eu esse veniam cupidatat dolor in dolore.Enim sit minim ex voluptate ut aliquip ad labore ipsum.Irure laboris dolore voluptate in minim.Excepteur anim des ....</p>
            </Column>
          </Row>
          <Row className="m-t-xl">
            <Column className="m-r m-b" size="33%" small="100%">
              <img className="img-prof" src={require('../../../img-layout/img16-9.jpg') } alt="prof-img" />
            </Column>
            <Column className="" small="100%">
              <h3>Professor Nakasuka</h3>
              <p className="m-t">Minim mollit eiusmod culpa laborum ad laboris cupidatat.Ipsum sunt consequat non in nostrud cillum reprehenderit voluptate dolore.Nulla veniam fugiat laborum consequat eu dolor ex sit sint magna.
                Nisi proident quis commodo incididunt.Labore sint proident officia id.Ea sit amet dolore est nulla dolor labore non dolore eu aliquip nisi.Quis do cupidatat in culpa et laboris consectetur excepteur nisi.Laboris Lorem cupidatat veniam incididunt amet sit.Veniam in adipisicing exercitation pariatur.Minim deserunt amet enim consectetur duis nostrud est pariatur ea.
                In nulla laboris ut quis consequat id dolor deserunt.Aliquip Lorem proident laboris in dolor Lorem eu adipisicing est consectetur et sit.Irure labore deserunt voluptate excepteur.
                Velit elit eiusmod est nostrud consectetur ad.Non adipisicing mollit cillum qui id qui eu esse veniam cupidatat dolor in dolore.Enim sit minim ex voluptate ut aliquip ad labore ipsum.Irure laboris dolore voluptate in minim.Excepteur anim des ....</p>
            </Column>
          </Row>
        </div>*/}


      </div>
    );
  }
  /* End React Component LifeCycle Methods */
}

export default AboutView;

//Unit test entry point
export const AboutViewTest = AboutView;


/** WEBPACK FOOTER **
 ** ./src/js/views/AboutView/AboutView.jsx
 **/